import { tokenStorage } from './storage-keys';
import { appConfig } from '@/config/app-config';

export interface ApiRequestOptions {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  url: string;
  data?: unknown;
  params?: Record<string, string>;
  headers?: Record<string, string>;
}

export async function apiRequest<T = unknown>(
  options: ApiRequestOptions
): Promise<[Error | null, T | null]> {
  try {
    const token = tokenStorage.get();
    const baseURL = appConfig.API_BASE_URL;

    const headers: HeadersInit = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    // Build URL with query params if provided
    let url = `${baseURL}${options.url}`;
    if (options.params) {
      const queryString = new URLSearchParams(options.params).toString();
      url = `${url}?${queryString}`;
    }

    const response = await fetch(url, {
      method: options.method,
      headers,
      body: options.data ? JSON.stringify(options.data) : undefined,
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    return [null, data as T];
  } catch (error) {
    console.error('API Request Error:', error);
    return [error as Error, null];
  }
}
